import React, { Component } from 'react';
import { Button } from '@trevor/ui-components';
import css from '../../css/module/billing.css';
import flex from '../../css/module/flex.css';
import modal from '../../css/module/modal.css';
import { validateEmail } from '../../util/helpers/string-helpers';
import { post } from '../../util/helpers/ajax-helpers';
import AjaxSpinner from '../AjaxSpinner';

class UpdateReceiptsEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      email: this.props.existingEmail, // an object containing the address and company details
    };
    this.save = this.save.bind(this);
    this.content = this.content.bind(this);
  }

  save() {
    this.setState({
      saving: true,
    });
    post('updating email', '/api/subscription/email', {
      email: this.state.email,
    }).then(() => {
      this.props.onUpdated(this.state.email);
    });
  }

  content() {
    return (
      <div>
        {this.state.saving ? (
          <div className={`${flex.middle} margin-top-30`}>
            <AjaxSpinner small />
          </div>
        ) : (
          <div className={css.formContainer}>
            <div className={css.inputLine}>
              <div className={css.formName}>
                <span>Email</span>
              </div>
              <input
                value={this.state.email}
                placeholder="name@company.com"
                onChange={(e) => this.setState({ email: e.target.value })}
                type="text"
              />
            </div>
          </div>
        )}
        <div
          className={`${flex.row} w-100 margin-top-20 ${flex.justifyContentEnd}`}
        >
          <Button
            variant="secondary"
            className="margin-right-10"
            onClick={this.props.closeModal}
            disabled={this.state.saving}
          >
            Cancel
          </Button>
          <Button
            onClick={this.save}
            disabled={!validateEmail(this.state.email) || this.state.saving}
          >
            Save
          </Button>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div
        style={{
          maxWidth: '600px',
          minWidth: '500px',
          padding: '10px 30px 30px',
          color: '#000',
        }}
        className={modal.container}
      >
        <h1>Send receipts to</h1>
        {this.content()}
      </div>
    );
  }
}

export default UpdateReceiptsEmail;
